import { Institution } from 'pages/institutions';
import InstitutionView from 'pages/institutions/institution_view';
import InstitutionForm from 'pages/institutions/form/institution.form';
import CreateCifa2025 from 'pages/service_management/Cifa/2025/CifaCrud2025/CreateCifa2025';
import CreateFederalSchoolFeeding2025 from 'pages/service_management/Cifa/2025/CifaCrud2025/FederalSchoolFeeding/CreateFederalSchoolFeeding2025';
import ViewFederalSchoolFeeding2025 from 'pages/service_management/Cifa/2025/CifaCrud2025/FederalSchoolFeeding/ViewFederalSchoolFeeding2025';
import CreateMunicipalSchoolFeeding2025 from 'pages/service_management/Cifa/2025/CifaCrud2025/MunicipalSchoolFeeding/CreateMunicipalSchoolFeeding2025';
import CreateStateSchoolFeeding2025 from 'pages/service_management/Cifa/2025/CifaCrud2025/StateSchoolFeeding/CreateStateSchoolFeeding2025';
import ViewCifa2025 from 'pages/service_management/Cifa/2025/CifaCrud2025/ViewCifa2025';
import ManageCifa2025 from 'pages/service_management/Cifa/2025/manage_cifa_2025';
import ComplianceTerm from 'pages/service_management/Cifa/2026/CifaCrud2026/ComplianceTerm';
import CreateCifa from 'pages/service_management/Cifa/2026/CifaCrud2026/CreateCifa';
import TechAssist from 'pages/service_management/Cifa/2026/CifaCrud2026/TechAssist';
import ManageCifa from 'pages/service_management/Cifa/2026/ManageCifa';
import MenuCifa from 'pages/service_management/menu_cifa';
import MenuService from 'pages/service_management/menu_service';
import { TermsOfUseAndConfidentiality } from 'pages/terms_of_use_and_confidentiality';
import { ManageUser, MenuUser, UserView, UserForm } from 'pages/user';
import React from 'react';
import Home from '../pages/home';
import { Login, LoginValidation } from '../pages/login';
import NotFoundPage from '../pages/not_found_page';
import { ROUTES } from './constants';
import ViewMunicipalSchoolFeeding2025 from 'pages/service_management/Cifa/2025/CifaCrud2025/MunicipalSchoolFeeding/ViewMunicipalSchoolFeeding2025';
import ViewStateSchoolFeeding2025 from 'pages/service_management/Cifa/2025/CifaCrud2025/StateSchoolFeeding/ViewStateSchoolFeeding2025';
import EditCifa2025 from 'pages/service_management/Cifa/2025/CifaCrud2025/EditCifa2025';
import EditFederalSchoolFeeding2025 from 'pages/service_management/Cifa/2025/CifaCrud2025/FederalSchoolFeeding/EditFederalSchoolFeeding2025';
import EditStateSchoolFeeding2025 from 'pages/service_management/Cifa/2025/CifaCrud2025/StateSchoolFeeding/EditStateSchoolFeeding2025';
import EditMunicipalSchoolFeeding2025 from 'pages/service_management/Cifa/2025/CifaCrud2025/MunicipalSchoolFeeding/EditMunicipalSchoolFeeding2025';
import FirstRegisterUser from 'pages/first_register_user';
import InitialSteps from 'pages/first_register_user/initial_steps';
import TermOfAdhesion from 'pages/term_of_adhesion';
import RegisterTermOfAdhesion from 'pages/term_of_adhesion/register_term_of_adhesion';
import ViewTermsAdhesion from 'pages/term_of_adhesion/view_terms_adhesion';
import ValidateTermAdhesion from 'pages/term_of_adhesion/validate_term_adhesion';
import EditTermOfAdhesion from 'pages/term_of_adhesion/edit_term_adhesion';
import UserFormCreate from 'pages/user/user_form_create';
import ConfirmSchoolFeeding from 'pages/service_management/Cifa/2025/CifaCrud2025/ConfirmSchoolFeeding';
import CreateConfirmSchoolFeeding from 'pages/service_management/Cifa/2025/CifaCrud2025/ConfirmSchoolFeeding/CreateConfirmSchoolFeeding';
import EditConfirmSchoolFeeding from 'pages/service_management/Cifa/2025/CifaCrud2025/ConfirmSchoolFeeding/EditConfirmSchoolFeeding';
import {
  ManagePermission,
  PermissionFormPage,
  PermissionViewPage,
} from 'pages/permission';
import PacoteFormularios from 'pages/forms/pacote_formularios';
import FormularioSecretariaMunicipalAgriculturaVisualizar from 'pages/forms/pacote_formularios/secretaria_municipal_agricultura/visualizar';
import FormularioSecretariaMunicipalAgriculturaEditar from 'pages/forms/pacote_formularios/secretaria_municipal_agricultura/editar';
import FormPMAFVisualizar from 'pages/forms/pacote_formularios/politica_municipal_agricultura_familiar/visualizar';
import FormPMAFEditar from 'pages/forms/pacote_formularios/politica_municipal_agricultura_familiar/editar';
import FormComunidadesQuilombolasVisualizar from 'pages/forms/pacote_formularios/comunidades_rurais_tradicionais/visualizar';
import FormularioComunidadesQuilombolasEditar from 'pages/forms/pacote_formularios/comunidades_rurais_tradicionais/editar';
import FormQuestoesAmbientaisVisualizar from 'pages/forms/pacote_formularios/questoes_ambientais/visualizar';
import FormQuestoesAmbientaisEditar from 'pages/forms/pacote_formularios/questoes_ambientais/editar';
import PacoteFormulariosVisualizar from 'pages/forms/pacote_formularios/stateManager/visualizar';
import FormularioCMDRSEditar from 'pages/forms/pacote_formularios/cmdrs/editar';
import FormularioSIMEditar from 'pages/forms/pacote_formularios/servico_de_inspecao_municipal/editar';
import FormularioCMDRSVisualizar from 'pages/forms/pacote_formularios/cmdrs/visualizar';
import FormularioSIMVisualizar from 'pages/forms/pacote_formularios/servico_de_inspecao_municipal/visualizar';
import FinancialResource from 'pages/service_management/Cifa/2026/CifaCrud2026/FinancialResource';
import SchoolFeeding2026 from 'pages/service_management/Cifa/2026/CifaCrud2026/SchoolFeeding';
import ViewComplianceTerm from 'pages/service_management/Cifa/2026/CifaCrud2026/ComplianceTerm/view';
import ViewTechAssist from 'pages/service_management/Cifa/2026/CifaCrud2026/TechAssist/view';
import ViewFinancialResource from 'pages/service_management/Cifa/2026/CifaCrud2026/FinancialResource/view';
import ViewSchoolFeeding from 'pages/service_management/Cifa/2026/CifaCrud2026/SchoolFeeding/view';
import ViewCifa from 'pages/service_management/Cifa/2026/CifaCrud2026/ViewCifa';
import Cicaaf from 'pages/service_management/cicaaf/coleta/cicaaf';
import { DadosGeraisCicaaf } from 'pages/service_management/cicaaf/coleta/dadosGerais';
import { ProducaoComercializacaoCicaaf } from 'pages/service_management/cicaaf/ProductionComercialization';
import { ProdutosProcessadosCicaaf } from 'pages/service_management/cicaaf/processedProducts';
import { GerenciamentoColetasCicaaf } from 'pages/service_management/cicaaf/GerenciamentoColetas';
import { GerenciamentoViewCicaaf } from 'pages/service_management/cicaaf/GerenciamentoColetas/visualizar';
import HomeCicaaf from 'pages/service_management/cicaaf/homeCicaaf';
import { GerenciamentoEditCicaaf } from 'pages/service_management/cicaaf/GerenciamentoColetas/editar';
import { DadosFamiliaIncluir } from 'pages/service_management/Cuffa/IdentificacaoFamiliar/Incluir';
import { VisitasInstituicoesIncluir } from 'pages/service_management/Cuffa/VisitasInstituicoes/Incluir';
import InspecaoProdutosIncluir from 'pages/service_management/Cuffa/InspecaoProdutos/Incluir';
import { InformarDificuldadesCicaaf } from 'pages/service_management/cicaaf/coleta/informar_dificuldades/page';
import SelosAgregacaoValor from 'pages/service_management/Cuffa/SelosAgregacao/Incluir';
import CanaisComercializacao from 'pages/service_management/Cuffa/CanaisComercializacao/Incluir';
import CreditoFinanciamento from 'pages/service_management/Cuffa/CreditoFinanciamento/Incluir';
import { FontesRendaFamilia } from 'pages/service_management/Cuffa/FonteRendaFamiliar/Incluir';
import RendaParticipacaoFeminina from 'pages/service_management/Cuffa/ParticipacaoFeminina/Incluir';
import DificuldadesProducao from 'pages/service_management/Cuffa/DificuldadesProducao/Incluir';
import GerenciarCuffaHome from 'pages/service_management/Cuffa';
import CategoriaFundiariaIncluir from 'pages/service_management/Cuffa/CategoriaFundiaria/Incluir';
import { CadratroProdutosIncluir } from 'pages/service_management/Cuffa/CadastrarProdutos/Incluir';
import DadosFamiliaVisualizar from 'pages/service_management/Cuffa/IdentificacaoFamiliar/Visualizar';
import VisitasInstituicoesVisualizar from 'pages/service_management/Cuffa/VisitasInstituicoes/Visualizar';
import InspecaoProdutosVisualizar from 'pages/service_management/Cuffa/InspecaoProdutos/Visualizar';
import SelosAgregacaoValorVisualizar from 'pages/service_management/Cuffa/SelosAgregacao/Visualizar';
import CanaisComercializacaoVisualizar from 'pages/service_management/Cuffa/CanaisComercializacao/Visualizar';
import CreditoFinanciamentoVisualizar from 'pages/service_management/Cuffa/CreditoFinanciamento/Visualizar';
import FontesRendaFamiliaVisualizar from 'pages/service_management/Cuffa/FonteRendaFamiliar/Visualizar';
import RendaParticipacaoFemininaVisualizar from 'pages/service_management/Cuffa/ParticipacaoFeminina/Visualizar';
import DificuldadesProducaoVisualizar from 'pages/service_management/Cuffa/DificuldadesProducao/Visualizar';
import ProducaoAgroecologica from 'pages/service_management/Cuffa/ProducaoAgroecologica/Incluir';
import ProducaoConvencional from 'pages/service_management/Cuffa/DetalhesProducao/Incluir';
import ProdutosProcessados from 'pages/service_management/Cuffa/ProdutosProcessados/Incluir';
import CuffaListar from 'pages/service_management/Cuffa/listar';
import ProducaoAgroecologicaVisualizar from 'pages/service_management/Cuffa/ProducaoAgroecologica/Visualizar';
import ProducaoConvencionalVisualizar from 'pages/service_management/Cuffa/DetalhesProducao/Visualizar';
import ProdutosProcessadosVisualizar from 'pages/service_management/Cuffa/ProdutosProcessados/Visualizar';
import CadrastroProdutosVisualizar from 'pages/service_management/Cuffa/CadastrarProdutos/Visualizar';
import { AssinaturaCuffaIncluir } from 'pages/service_management/Cuffa/assinatura/Incluir';
import { DadosFamiliaEditar } from 'pages/service_management/Cuffa/IdentificacaoFamiliar/Editar';
import FormularioComunidadesQuilombolasSteps from 'pages/forms/pacote_formularios/comunidades_rurais_tradicionais/editar/steps';

export interface RouteConfig {
  path: string;
  element: React.FC<any>;
  protectedRoute: boolean;
  exact?: boolean;
}

const RoutesConfig: RouteConfig[] = [
  {
    path: '*',
    element: NotFoundPage,
    protectedRoute: false,
  },
  {
    path: ROUTES.LOGIN,
    element: Login,
    protectedRoute: false,
  },
  {
    path: ROUTES.LOGIN_VALIDATION,
    element: LoginValidation,
    protectedRoute: false,
  },
  {
    path: ROUTES.TERMS_OF_USE_AND_CONFIDENTIALITY,
    element: TermsOfUseAndConfidentiality,
    protectedRoute: false,
  },
  {
    path: ROUTES.HOME,
    element: Home,
    protectedRoute: true,
  },
  {
    path: ROUTES.MENU_USER,
    element: MenuUser,
    protectedRoute: true,
  },
  {
    path: ROUTES.MANAGE_PERMISSIONS,
    element: ManagePermission,
    protectedRoute: true,
  },
  {
    path: ROUTES.PERMISSIONS_EDIT,
    element: PermissionFormPage,
    protectedRoute: true,
  },
  {
    path: ROUTES.PERMISSIONS_VIEW,
    element: PermissionViewPage,
    protectedRoute: true,
  },
  {
    path: ROUTES.PERMISSIONS_CREATE,
    element: PermissionFormPage,
    protectedRoute: true,
  },
  {
    path: ROUTES.MANAGE_USER,
    element: ManageUser,
    protectedRoute: true,
  },
  {
    path: ROUTES.USER_CREATE,
    element: UserForm,
    protectedRoute: false,
  },
  {
    path: ROUTES.USER_EDIT,
    element: UserForm,
    protectedRoute: true,
  },
  {
    path: ROUTES.USER_VIEW,
    element: UserView,
    protectedRoute: true,
  },
  {
    path: ROUTES.INSTITUTION,
    element: Institution,
    protectedRoute: true,
  },
  {
    path: ROUTES.INSTITUTION_VIEW,
    element: InstitutionView,
    protectedRoute: true,
  },
  {
    path: ROUTES.CICAAF,
    element: HomeCicaaf,
    protectedRoute: true,
  },
  {
    path: ROUTES.INSTITUTION_EDIT,
    element: InstitutionForm,
    protectedRoute: true,
  },
  {
    path: ROUTES.MANAGE_SERVICE,
    element: MenuService,
    protectedRoute: true,
  },
  {
    path: ROUTES.MANAGE_CIFA,
    element: MenuCifa,
    protectedRoute: true,
  },
  {
    path: ROUTES.CIFA2025,
    element: ManageCifa2025,
    protectedRoute: true,
  },
  {
    path: ROUTES.INCLUDE_CIFA_2025,
    element: CreateCifa2025,
    protectedRoute: true,
  },
  {
    path: ROUTES.CIFA2026,
    element: ManageCifa,
    protectedRoute: true,
  },
  {
    path: ROUTES.INCLUDE_CIFA_2026,
    element: CreateCifa,
    protectedRoute: true,
  },
  {
    path: ROUTES.COMPLIANCE_TERM_2026,
    element: ComplianceTerm,
    protectedRoute: true,
  },
  {
    path: ROUTES.TECH_ASSIST_2026,
    element: TechAssist,
    protectedRoute: true,
  },

  {
    path: ROUTES.FINANCIAL_RESOURCE_2026,
    element: FinancialResource,
    protectedRoute: true,
  },
  {

    path: ROUTES.SCHOOL_FEEDING_2026,
    element: SchoolFeeding2026,
    protectedRoute: true,
  },
  {
    path: ROUTES.CIFA2027,
    element: ManageCifa,
    protectedRoute: true,
  },
  {
    path: ROUTES.INCLUDE_CIFA_2027,
    element: CreateCifa,
    protectedRoute: true,
  },
  {
    path: ROUTES.COMPLIANCE_TERM_2027,
    element: ComplianceTerm,
    protectedRoute: true,
  },
  {
    path: ROUTES.TECH_ASSIST_2027,
    element: TechAssist,
    protectedRoute: true,
  },
  {
    path: ROUTES.FINANCIAL_RESOURCE_2027,
    element: FinancialResource,
    protectedRoute: true,
  },
  {
    path: ROUTES.SCHOOL_FEEDING_2027,
    element: SchoolFeeding2026,
    protectedRoute: true,
  },
  {
    path: ROUTES.CREATE_FEDERAL_SCHOOL_FEEDING_2025,
    element: CreateFederalSchoolFeeding2025,
    protectedRoute: true,
  },
  {
    path: ROUTES.CREATE_STATE_SCHOOL_FEEDING_2025,
    element: CreateStateSchoolFeeding2025,
    protectedRoute: true,
  },
  {
    path: ROUTES.CREATE_MUNICIPAL_SCHOOL_FEEDING_2025,
    element: CreateMunicipalSchoolFeeding2025,
    protectedRoute: true,
  },
  {
    path: ROUTES.CREATE_CONFIRM_SCHOOL_FEEDING_2025,
    element: CreateConfirmSchoolFeeding,
    protectedRoute: true,
  },
  {
    path: ROUTES.VIEW_CIFA_2025,
    element: ViewCifa2025,
    protectedRoute: true,
  },
  {
    path: ROUTES.VIEW_FEDERAL_SCHOOL_FEEDING_2025,
    element: ViewFederalSchoolFeeding2025,
    protectedRoute: true,
  },
  {
    path: ROUTES.VIEW_MUNICIPAL_SCHOOL_FEEDING_2025,
    element: ViewMunicipalSchoolFeeding2025,
    protectedRoute: true,
  },
  {
    path: ROUTES.VIEW_STATE_SCHOOL_FEEDING_2025,
    element: ViewStateSchoolFeeding2025,
    protectedRoute: true,
  },
  {
    path: ROUTES.EDIT_CIFA_2025,
    element: EditCifa2025,
    protectedRoute: true,
  },
  {
    path: ROUTES.EDIT_FEDERAL_SCHOOL_FEEDING_2025,
    element: EditFederalSchoolFeeding2025,
    protectedRoute: true,
  },
  {
    path: ROUTES.EDIT_STATE_SCHOOL_FEEDING_2025,
    element: EditStateSchoolFeeding2025,
    protectedRoute: true,
  },
  {
    path: ROUTES.EDIT_MUNICIPAL_SCHOOL_FEEDING_2025,
    element: EditMunicipalSchoolFeeding2025,
    protectedRoute: true,
  },
  {
    path: ROUTES.EDIT_CONFIRM_SCHOOL_FEEDING_2025,
    element: EditConfirmSchoolFeeding,
    protectedRoute: true,
  },
  {
    path: ROUTES.CONFIRM_SCHOOL_FEEDING_2025,
    element: ConfirmSchoolFeeding,
    protectedRoute: true,
  },
  {
    path: ROUTES.FIRSTUSER,
    element: FirstRegisterUser,
    protectedRoute: false,
  },
  {
    path: ROUTES.FIRSTUSERCREATE,
    element: UserFormCreate,
    protectedRoute: false,
  },
  {
    path: ROUTES.FIRSTUSERSTEPS,
    element: InitialSteps,
    protectedRoute: false,
  },
  {
    path: ROUTES.TERMOFADHESION,
    element: TermOfAdhesion,
    protectedRoute: true,
  },
  {
    path: ROUTES.REGISTERTERMOFADHESION,
    element: RegisterTermOfAdhesion,
    protectedRoute: true,
  },
  {
    path: ROUTES.VIEWTERMSADHESION,
    element: ViewTermsAdhesion,
    protectedRoute: true,
  },
  {
    path: ROUTES.VALIDATETERMSADHESION,
    element: ValidateTermAdhesion,
    protectedRoute: true,
  },
  {
    path: ROUTES.EDITTETERMSADHESION,
    element: EditTermOfAdhesion,
    protectedRoute: true,
  },
  {
    path: ROUTES.PACOTE_FORMULARIOS,
    element: PacoteFormularios,
    protectedRoute: true,
  },
  {
    path: ROUTES.PACOTE_FORMULARIOS_AGRICULTURA_FAMILIAR_VISUALIZAR,
    element: FormularioSecretariaMunicipalAgriculturaVisualizar,
    protectedRoute: true,
  },
  {
    path: ROUTES.PACOTE_FORMULARIOS_AGRICULTURA_FAMILIAR_EDITAR,
    element: FormularioSecretariaMunicipalAgriculturaEditar,
    protectedRoute: true,
  },
  {
    path: ROUTES.PACOTE_FORMULARIOS_POLITICA_MUNICIPAL_AGRICULTURA_FAMILIAR_VISUALIZAR,
    element: FormPMAFVisualizar,
    protectedRoute: true,
  },
  {
    path: ROUTES.PACOTE_FORMULARIOS_POLITICA_MUNICIPAL_AGRICULTURA_FAMILIAR_EDITAR,
    element: FormPMAFEditar,
    protectedRoute: true,
  },
  {
    path: ROUTES.PACOTE_FORMULARIOS_COMUNIDADES_RURAIS_TRADICIONAIS_EDITAR,
    element: FormularioComunidadesQuilombolasEditar,
    protectedRoute: true,
  },
  {
    path: ROUTES.PACOTE_FORMULARIOS_COMUNIDADES_RURAIS_TRADICIONAIS_VISUALIZAR,
    element: FormComunidadesQuilombolasVisualizar,
    protectedRoute: true,
  },
  {
    path: ROUTES.PACOTE_FORMULARIOS_QUESTOES_AMBIENTAIS_VISUALIZAR,
    element: FormQuestoesAmbientaisVisualizar,
    protectedRoute: true,
  },
  {
    path: ROUTES.PACOTE_FORMULARIOS_QUESTOES_AMBIENTAIS_EDITAR,
    element: FormQuestoesAmbientaisEditar,
    protectedRoute: true
  },
  {
    path: ROUTES.COMUNIDADES_RURAIS_TRADICIONAIS,
    element: FormularioComunidadesQuilombolasSteps,
    protectedRoute: true
  },
  {

    path: ROUTES.PACOTE_FORMULARIOS_ID,
    element: PacoteFormulariosVisualizar,
    protectedRoute: true,
  },
  {
    path: ROUTES.PACOTE_FORMULARIOS_CMDRS_EDITAR,
    element: FormularioCMDRSEditar,
    protectedRoute: true,
  },
  {
    path: ROUTES.PACOTE_FORMULARIOS_VISUALIZAR_EDITAR,
    element: FormularioCMDRSVisualizar,
    protectedRoute: true
  },
  {
    path: ROUTES.PACOTE_FORMULARIOS_SIM_EDITAR,
    element: FormularioSIMEditar,
    protectedRoute: true,
  },
  {
    path: ROUTES.PACOTE_FORMULARIOS_SIM_VISUALIZAR,
    element: FormularioSIMVisualizar,
    protectedRoute: true,
  },

  // Rotas de visualização CIFA 2026
  {
    path: ROUTES.VIEW_CIFA_2026,
    element: ViewCifa,
    protectedRoute: true,
  },
  {
    path: ROUTES.VIEW_COMPLIANCE_TERM_2026,
    element: ViewComplianceTerm,
    protectedRoute: true,
  },
  {
    path: ROUTES.VIEW_TECH_ASSIST_2026,
    element: ViewTechAssist,
    protectedRoute: true,
  },
  {
    path: ROUTES.VIEW_FINANCIAL_RESOURCE_2026,
    element: ViewFinancialResource,
    protectedRoute: true,
  },
  {
    path: ROUTES.VIEW_SCHOOL_FEEDING_2026,
    element: ViewSchoolFeeding,
    protectedRoute: true,
  },

  // Rotas de visualização CIFA 2027
  {
    path: ROUTES.VIEW_CIFA_2027,
    element: ViewCifa,
    protectedRoute: true,
  },
  {
    path: ROUTES.VIEW_COMPLIANCE_TERM_2027,
    element: ViewComplianceTerm,
    protectedRoute: true,
  },
  {
    path: ROUTES.VIEW_TECH_ASSIST_2027,
    element: ViewTechAssist,
    protectedRoute: true,
  },
  {
    path: ROUTES.VIEW_FINANCIAL_RESOURCE_2027,
    element: ViewFinancialResource,
    protectedRoute: true,
  },
  {
    path: ROUTES.VIEW_SCHOOL_FEEDING_2027,
    element: ViewSchoolFeeding,
    protectedRoute: true,
  },
  {
    path: ROUTES.DADOS_GERAIS_CICAAF,
    element: DadosGeraisCicaaf,
    protectedRoute: true,
  },
  {
    path: ROUTES.PRODUCAO_COMERCIALIZACAO_CICAAF,
    element: ProducaoComercializacaoCicaaf,
    protectedRoute: true,
  },
  {
    path: ROUTES.PRODUTOS_PROCESSADOS_CICAAF,
    element: ProdutosProcessadosCicaaf,
    protectedRoute: true,
  },
  {
    path: ROUTES.GERENCIAMENTO_COLETAS_CICAAF,
    element: GerenciamentoColetasCicaaf,
    protectedRoute: true,
  },
  {
    path: ROUTES.INFORMAR_DIFICULDADES_CICAAF,
    element: InformarDificuldadesCicaaf,
    protectedRoute: true,
  },
  {
    path: ROUTES.GERENCIAMENTO_COLETAS_CICAAF_VISUALIZAR,
    element: GerenciamentoViewCicaaf,
    protectedRoute: true,
  },
  {
    path: ROUTES.GERENCIAMENTO_COLETAS_CICAAF_EDITAR,
    element: GerenciamentoEditCicaaf,
    protectedRoute: true,
  },
  {
    path: ROUTES.COLETA_CICAAF,
    element: Cicaaf,
    protectedRoute: true,
  },
  {
    path: ROUTES.CUFFA,
    element: GerenciarCuffaHome,
    protectedRoute: true,
  },
  {
    path: ROUTES.IDENTIFICACAO_FAMILIAR_CUFFA_INCLUIR,
    element: DadosFamiliaIncluir,
    protectedRoute: true,
  },
  {
    path: ROUTES.IDENTIFICACAO_FAMILIAR_CUFFA_EDITAR,
    element: DadosFamiliaEditar,
    protectedRoute: true,
  },
  {
    path: ROUTES.IDENTIFICACAO_FAMILIAR_CUFFA_VISUALIZAR,
    element: DadosFamiliaVisualizar,
    protectedRoute: true,
  },
  {
    path: ROUTES.CATEGORIA_FUNDIARIA_INCLUIR,
    element: CategoriaFundiariaIncluir,
    protectedRoute: true,
  },
  {
    path: ROUTES.CATEGORIA_FUNDIARIA_VISUALIZAR,
    element: CadrastroProdutosVisualizar,
    protectedRoute: true,
  },

  {
    path: ROUTES.CADASTRAR_PRODUTOS_INCLUIR,
    element: CadratroProdutosIncluir,
    protectedRoute: true,
  },

  {
    path: ROUTES.CADASTRAR_PRODUTOS_VISUALIZAR,
    element: CadrastroProdutosVisualizar,
    protectedRoute: true,
  },

  {
    path: ROUTES.PRODUCAO_AGROECOLOGICA_INCLUIR,
    element: ProducaoAgroecologica,
    protectedRoute: true,
  },
  {
    path: ROUTES.PRODUCAO_AGROECOLOGICA_VISUALIZAR,
    element: ProducaoAgroecologicaVisualizar,
    protectedRoute: true,
  },
  {
    path: ROUTES.DETALHES_PRODUCAO_INCLUIR,
    element: ProducaoConvencional,
    protectedRoute: true,
  },
  {
    path: ROUTES.DETALHES_PRODUCAO_VISUALIZAR,
    element: ProducaoConvencionalVisualizar,
    protectedRoute: true,
  },
  {
    path: ROUTES.PRODUTOS_PROCESSADOS_INCLUIR,
    element: ProdutosProcessados,
    protectedRoute: true,
  },
  {
    path: ROUTES.PRODUTOS_PROCESSADOS_VISUALIZAR,
    element: ProdutosProcessadosVisualizar,
    protectedRoute: true,
  },
  {
    path: ROUTES.VISITAS_INSTITUICOES_CUFFA_INCLUIR,
    element: VisitasInstituicoesIncluir,
    protectedRoute: true,
  },
  {
    path: ROUTES.VISITAS_INSTITUICOES_CUFFA_VISUALIZAR,
    element: VisitasInstituicoesVisualizar,
    protectedRoute: true,
  },
  {
    path: ROUTES.INSPECAO_PRODUTOS_CUFFA_INCLUIR,
    element: InspecaoProdutosIncluir,
    protectedRoute: true,
  },
  {
    path: ROUTES.INSPECAO_PRODUTOS_CUFFA_VISUALIZAR,
    element: InspecaoProdutosVisualizar,
    protectedRoute: true,
  },
  {
    path: ROUTES.SELOS_AGREGACAO_CUFFA_INCLUIR,
    element: SelosAgregacaoValor,
    protectedRoute: true,
  },
  {
    path: ROUTES.SELOS_AGREGACAO_CUFFA_VISUALIZAR,
    element: SelosAgregacaoValorVisualizar,
    protectedRoute: true,
  },
  {
    path: ROUTES.CANAIS_COMERCIALIZACAO_CUFFA_INCLUIR,
    element: CanaisComercializacao,
    protectedRoute: true,
  },
  {
    path: ROUTES.CANAIS_COMERCIALIZACAO_CUFFA_VISUALIZAR,
    element: CanaisComercializacaoVisualizar,
    protectedRoute: true,
  },
  {
    path: ROUTES.CREDITO_FINANCIAMENTO_CUFFA_INCLUIR,
    element: CreditoFinanciamento,
    protectedRoute: true,
  },
  {
    path: ROUTES.CREDITO_FINANCIAMENTO_CUFFA_VISUALIZAR,
    element: CreditoFinanciamentoVisualizar,
    protectedRoute: true,
  },
  {
    path: ROUTES.FONTES_RENDA_FAMILIA_CUFFA_INCLUIR,
    element: FontesRendaFamilia,
    protectedRoute: true,
  },
  {
    path: ROUTES.FONTES_RENDA_FAMILIA_CUFFA_VISUALIZAR,
    element: FontesRendaFamiliaVisualizar,
    protectedRoute: true,
  },
  {
    path: ROUTES.PARTICIPACAO_FEMININA_CUFFA_INCLUIR,
    element: RendaParticipacaoFeminina,
    protectedRoute: true,
  },
  {
    path: ROUTES.PARTICIPACAO_FEMININA_CUFFA_VISUALIZAR,
    element: RendaParticipacaoFemininaVisualizar,
    protectedRoute: true,
  },
  {
    path: ROUTES.DIFICULDADES_PRODUCAO_CUFFA_INCLUIR,
    element: DificuldadesProducao,
    protectedRoute: true,
  },
  {
    path: ROUTES.DIFICULDADES_PRODUCAO_CUFFA_VISUALIZAR,
    element: DificuldadesProducaoVisualizar,
    protectedRoute: true,
  },
  {
    path: ROUTES.LISTAR_CUFFA,
    element: CuffaListar,
    protectedRoute: true,
  },
  {
    path: ROUTES.CUFFA_ASSINATURA_INCLUIR,
    element: AssinaturaCuffaIncluir,
    protectedRoute: true,
  }
];

export default RoutesConfig;
